// extracted by mini-css-extract-plugin
module.exports = {"root":"FeedbackPostCommentsInput_root__IwhAv","controls":"FeedbackPostCommentsInput_controls__peyvv","submit":"FeedbackPostCommentsInput_submit__jhJ_u"};